import { Loader2 } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import LogoutIcon from '@/assets/icons/logout.svg';
import { useChannelsStore } from '@/components/pages/channels/use-channels-store';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useEditCampaignContext } from '@/contexts/edit-campaign-context';

interface HeaderProps {
  isFormDirty: boolean;
  isSaving: boolean;
  onQuit: () => void;
}

export function Header({ isFormDirty, isSaving, onQuit }: HeaderProps) {
  const openingTitle = useChannelsStore(s => s.opening?.title);
  const { campaign, isCompleted } = useEditCampaignContext();
  const isReadonly = campaign?.is_readonly;

  return (
    <div className="flex items-center justify-between bg-white p-2">
      <div className="flex items-center gap-4">
        <Button variant="secondary" type="button" onClick={onQuit}>
          <img src={LogoutIcon} alt="" />
          <FormattedMessage defaultMessage="Quit" />
        </Button>
        <Typography variant="body1">{openingTitle}</Typography>
      </div>

      {!isCompleted && !isReadonly && (
        <Button type="submit" disabled={!isFormDirty || isSaving}>
          {isSaving && <Loader2 className="animate-spin" />}
          <FormattedMessage defaultMessage="Update campaign" />
        </Button>
      )}
    </div>
  );
}
